module.exports = __webpack_public_path__ + "img/pippaeddie.f12d03f4.png";